import { Card, CardContent, Typography, Box } from "@mui/material";
import { User, DollarSign } from "lucide-react";

export function OpportunitiesOtherUsersWidget() {
  const services = [
    { id: 1, user: "David Thompson", role: "Inspector", charge: "$250/inspection" },
    { id: 2, user: "Emily Rodriguez", role: "Appraiser", charge: "$500/appraisal" },
    { id: 3, user: "Lisa Wang", role: "Lender", charge: "1% origination fee" },
  ];

  return (
    <Card variant="outlined" sx={{borderRadius: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{ color: "#0d2561", fontWeight: 600, fontSize: "18px" }}
        >
          Market Insights
        </Typography>

        <Typography
          variant="body2"
          sx={{ fontSize: "14px", color: "text.secondary", mb: 3, mt: 1 }}
        >
          Discover what other platform members are charging for similar services.
        </Typography>

        <Box display="flex" flexDirection="column" gap={2}>
          {services.map((item) => (
            <Box key={item.id} display="flex" alignItems="flex-start" gap={1.5}>
              {/* 👤 icon */}
              <User style={{ width: 14, height: 14, color: "#0A66C2", marginTop: 2 }} />

              {/* Text block */}
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "14px", fontWeight: 500, color: "#212529", lineHeight: 1.3 }}
                >
                  {item.user} ({item.role})
                </Typography>

                <Box display="flex" alignItems="center" mt={0.5}>
                  <DollarSign style={{ width: 12, height: 12, color: "#9ca3af", marginRight: 4 }} />
                  <Typography
                    variant="caption"
                    sx={{ fontSize: "13px", color: "#9ca3af", lineHeight: 1.2 }}
                  >
                    {item.charge}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}